import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MngBaseButtonComponent } from './mng-base-button.component';
import { MngIconComponent } from '@mng/mng-icon';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatMenu, MatMenuContent, MatMenuTrigger } from '@angular/material/menu';
import { MngMenuButtonComponent } from './mng-menu-button.component';
import { NgTemplateOutlet } from '@angular/common';

// TODO: tooltip for disabled icon-buttons explaining why disabled
@Component({
  selector: 'mng-icon-button',
  imports: [
    MngIconComponent,
    MatIconButton,
    MatTooltip,
    MatMenuTrigger,
    MatMenu,
    MatMenuContent,
    MngMenuButtonComponent,
    NgTemplateOutlet
  ],
  template: `
    <ng-template #tplButtonIcon let-actionDef>
      @if (actionDef.iconTemplate) {
        <span [innerHTML]="actionDef.iconTemplate"></span>
      }
      <mng-icon [iconName]="iconName" [color]="iconColor" [fontSize]="fontSize" />
    </ng-template>

    @if (isVisible) {
      <div
        [matTooltip]="isDisabled ? getDisabledTooltipMessage() : getTooltipMessage()"
        [matTooltipPosition]="tooltipPosition"
        [matTooltipShowDelay]="isDisabled ? 50 : tooltipDelay"
      >
        @if (!actionDef.menu && !actionDef.menuRef) {
          <button
            type="button"
            mat-icon-button
            [color]="buttonColor"
            [id]="getButtonId()"
            [disabled]="isDisabled"
            [style.background-color]="actionDef.variant === 'flat' ? 'var(--theme-accent-500)' : ''"
            [style.color]="actionDef.variant === 'flat' ? 'white' : ''"
            (click)="executeAction($event)"
          >
            <ng-container *ngTemplateOutlet="tplButtonIcon; context: { $implicit: actionDef }" />
          </button>
        } @else {
          <button
            mat-icon-button
            [color]="buttonColor"
            [id]="getButtonId()"
            [disabled]="isDisabled"
            [matMenuTriggerFor]="actionDef.menu ? buttonMenu : actionDef.menuRef"
            [matMenuTriggerData]="{ actionArg: actionArg }"
            [style.background-color]="actionDef.variant === 'flat' ? 'var(--theme-accent-500)' : ''"
            [style.color]="actionDef.variant === 'flat' ? 'white' : ''"
            (click)="executeAction($event)"
          >
            <ng-container *ngTemplateOutlet="tplButtonIcon; context: { $implicit: actionDef }" />
          </button>
          <mat-menu #buttonMenu="matMenu">
            <ng-template matMenuContent>
              @for (menuActionDef of actionDef.menu; track menuActionDef; let i = $index) {
                <mng-menu-button
                  [actionDef]="menuActionDef"
                  [actionArg]="actionArg"
                  (executeMenuAction)="executeMenuAction($event, i)"
                />
              }
            </ng-template>
          </mat-menu>
        }
      </div>
    }
  `,
  styles: [
    `
      :host {
        display: inline-block;
      }

      ::ng-deep mng-icon-button mng-icon {
        display: inline !important;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MngIconButtonComponent extends MngBaseButtonComponent {
  constructor() {
    super();
    this.buttonTooltip = true;
  }
}
